import React from "react";
import "./TutorCardSkeleton.css";

const TutorCardSkeleton = () => {
  return (
    <div className="tutor-card skeleton-card">
      <div className="skeleton skeleton-image"></div>

      <div className="skeleton-content">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-subtitle"></div>
        <div className="skeleton skeleton-rating"></div>
        <div className="skeleton skeleton-price"></div>
      </div>
    </div>
  );
};

export default TutorCardSkeleton;
